import React, { useState, useEffect } from 'react';
import Image from '~/react/Image';
import BellIcon from '~/public/assets/icons/bell-icon.svg';
import BellIconDot from '~/public/assets/icons/bell-icon-dot.svg';
import CloseIcon from '~/public/assets/icons/close-x-round.svg';
import { setLinkCetDataVars, setWebActionCetDataVars } from '~/server/utils/cetTrackingHelper';
import storage from '~/public/assets/javascripts/storage';
import TimeAgo from '~/react/shared/TimeAgo';

const FULL_NOTIFICATION_MODAL_BP = 550;

const setCetItemDataAttributes = (url, entryId, type, index) => {
  const cetDataVars = {
    ...setLinkCetDataVars('nav_bar', url, entryId, type, 'site_header'),
    'data-vars-subunit-name': 'notification_center',
    'data-vars-subunit-type': 'component',
    'data-vars-position-in-subunit': index,
  };
  return cetDataVars;
};

const NotificationCenter = ({ editionInfo }) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);
  const [firstOpen, setFirstOpen] = useState(true);

  useEffect(() => {
    const oneDayAgo = new Date(Date.now() - (24 * 60 * 60 * 1000));
    const seenNotifications = storage.get('seenNotifications') || [];
    fetch('/client/notification-center')
      .then((response) => response.json())
      .then((data) => {
        const recentNotifications = data.notifications.filter((notification) => new Date(notification.date) > oneDayAgo);
        const newNotifications = recentNotifications.filter((notification) => !seenNotifications.includes(notification.id));
        setNotifications(recentNotifications);
        setUnreadNotifications(newNotifications.map((n) => n.id));
        setHasUnread(newNotifications.length > 0);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
        setNotifications([]);
      });
  }, []);

  useEffect(() => {
    if (isOpen && firstOpen) {
      window.doImpressions('notificationCenter');
      setFirstOpen(false);
    }
  }, [isOpen]);

  const toggleDropdown = () => {
    if (!isOpen) {
      if (window.innerWidth < FULL_NOTIFICATION_MODAL_BP) {
        document.body.classList.add('modal-open');
      }
      storage.set('seenNotifications', notifications.map((n) => n.id));
    } else {
      document.body.classList.remove('modal-open');
      setUnreadNotifications([]);
    }
    setIsOpen(!isOpen);
    setHasUnread(false);
  };

  return (
    <div className="notification-center js-cet-subunit">
      <button className="notification-center__button" onClick={toggleDropdown} {...setWebActionCetDataVars('nav_bar', 'open_notification_center')}>
        {!hasUnread && <BellIcon className="notification-center__button-bell-icon" />}
        {hasUnread && <BellIconDot className="notification-center__button-bell-icon-dot" />}
      </button>
      {isOpen && (
        <div className="notification-center__drop-down">
          <div className="notification-center__drop-down-header">
            <h2 className="notification-center__drop-down-header__title">Notifications</h2>
            <button className="notification-center__drop-down-header__close" onClick={toggleDropdown} aria-label="Close Notifications">
              <CloseIcon />
            </button>
          </div>
          <div className="notification-center__drop-down-body">
            {notifications.map((notification, index) => (
              <div
                className="notification-center__drop-down-item js-card"
                key={notification.id}
                {...setCetItemDataAttributes(notification.url, notification.entryId, 'card', index)}
              >
                {unreadNotifications.includes(notification.id) && <span className="notification-center__drop-down-item__dot" />}
                <div className="notification-center__drop-down-item__left">
                  <a
                    className="notification-center__drop-down-item__link"
                    href={notification.url}
                    {...setCetItemDataAttributes(notification.url, notification.entryId, 'card', index)}
                  >
                    {notification.title && <h3>{notification.title}</h3>}
                    {notification.message}
                  </a>
                  <div className="notification-center__drop-down-item__date">
                    <TimeAgo date={notification.date} useLongFormat live={false} hoursLimit={24} editionInfo={editionInfo} />
                  </div>
                </div>
                {notification.image && (
                  <div className="notification-center__drop-down-item__right">
                    <a
                      href={notification.url}
                      {...setCetItemDataAttributes(notification.url, notification.entryId, 'card', index)}
                    >
                      <Image
                        className="notification-center__drop-down-item__image"
                        image={notification.image}
                      />
                    </a>
                  </div>
                )}
              </div>
            ))}
            {notifications.length === 0 && (
              <div className="notification-center__empty">
                <h3>You’re all caught up on the news!</h3>
                <p>We will keep you up-to-date as our journalists work on new developments.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationCenter;
